
import vFooter from '../common/footer.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import {recommendBuyList} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
tabIndex: 1,
show: false,
show1: false,
isMask: false,
onFetching:false,
tabNum:0,
data:'',
bottomCount:'',
accessToken:this._wxTool.getAccessToken(),
state:'',
source:'',
noMore:'',
PrmPageNo:1,
totalPage:''
}
},
components: {
vFooter,
Actionsheet,
PopupPicker,
Scroller,
LoadMore
},
created(){
this._wxTool.auth();
this.wxInfo = this._wxTool.getUser();
this.userInfo = this._wxTool.getMember();
if(null==this.userInfo ){
console.log('need login');
this.$router.push('login')
}
this.getData()
},
methods: {
tab(e) {
let tabIndex = e;
if (tabIndex == this.tabIndex) {
if (tabIndex == 1) {
this.show = !this.show
this.isMask = !this.isMask
this.tabIndex = tabIndex
} else {
this.show1 = !this.show1
this.isMask = !this.isMask
this.tabIndex = tabIndex
}
return
}
this.tabIndex =  tabIndex
this.isMask = false
this.show = false
this.show1 = false
},
onScrollBottom(){
if (this.onFetching) {

} else {
if(this.totalPage==1){
return
}
if(this.totalPage<=this.PrmPageNo){
this.$vux.toast.text('亲！已经到底了！', 'middle')
return
}
this.onFetching = true
this.PrmPageNo+=1
let param ={
state:this.state.toString(),//状态0待审核1审核通过2无效3已成单4未成单
source:this.source,
accessToken :this.accessToken,
PrmPageNo:this.PrmPageNo
}
recommendBuyList(param).then(res=>{
if(res.code == 0){
console.log(res);
this.data = this.data.concat(res.data.memberRecommendBuyList)
this.totalPage = res.data.page.totalPage
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
console.log(res.data.page.totalPage)
setTimeout(() => {
if(res.data.page.totalPage>=this.PrmPageNo){
this.onFetching = false
}
}, 2000)
if(!this.data[0]){
this.noMore=true
return
}
this.noMore = false
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})

}
},
tabItem(e){
this.tabNum=e
switch(e){
case 1:
this.state = 0
this.source = ''
break;
case 2:
this.state = 1
this.source = ''
break;
case 3:
this.state = 2
this.source = ''
break;
case 4:
this.state = 3
this.source = ''
break;
case 5:
this.state = 4
this.source = ''
break;
case 6:
this.source = 'active'
this.state = ''
break;
case 7:
this.state = ''
this.source = 'post'
break;
}
this.PrmPageNo=1
this.totalPage = 1;
this.data = ''
this.getData()
this.isMask = false
this.show = false
this.show1 = false
},
reset(){
this.tabNum = 0;
this.isMask = false
this.show = false
this.show1 = false
this.state = ''
this.source = ''
this.totalPage = 1;
this.PrmPageNo=1
this.data = ''
this.getData()
},
getData(){
let param ={
state:this.state.toString(),//状态0待审核1审核通过2无效3已成单4未成单

source:this.source,
accessToken :this.accessToken
}
recommendBuyList(param).then(res=>{
if(res.code == 0){
console.log(res);
this.data = res.data.memberRecommendBuyList
console.log(this.data.memberRecommendBuyId)
this.totalPage = res.data.page.totalPage
if(!this.data[0]){
this.noMore=true
return
}
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})

this.noMore = false
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/plan/plan.vue